var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Sidebar'),_c('div',{staticClass:"main-panel"},[_c('Navbar'),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }